import styles from './opportunityjourneywrapper.module.css';
import { OpportunityJourneySquare } from './OpportunityJourneySquare';
import OpportunityDetails from './OpportunityDetails';
import ReminderComponent from '../ReminderComponent';
import InteractionComponent from '../InteractionComponent';
import { useGetAccountOwner } from '../../api/auth/useGetAccountOwner';
import { useOpportunityJourney } from "@/api/opportunities/useOpportunityJourney.js";

const OpportunityJourneyContainerWrapper = ({ oppId, oppType }) => {

  // Call the hook regardless; it should no-op / return loading until leadID exists.
  // If your hook *requires* a non-null, you can change it to accept { leadID } | null safely.
  const {opportunityData} = useOpportunityJourney(oppId, oppType)
  const leadID = opportunityData?.lead_id
  const accountOwner = useGetAccountOwner({ leadID });

  // Simple guards while data is loading
  if (!opportunityData) {
    return (
      <div className={`${styles.wrapper} bg-gray-100 p-4`}>
        <div className="animate-pulse text-sm text-gray-500">Loading opportunity…</div>
      </div>
    );
  }

  return (
    <div className={`${styles.wrapper} bg-gray-100`}>
      <OpportunityJourneySquare oppData={opportunityData} />
      <OpportunityDetails oppData={opportunityData} />
      <div className="flex flex-col md:flex-row md:justify-between w-full gap-4 md:gap-0 mr-0 md:mr-5 px-2 sm:px-0">
        <ReminderComponent leadID={leadID} owner={accountOwner} />
        <InteractionComponent key={leadID || 'no-lead'} leadID={leadID} owner={accountOwner} />
      </div>
    </div>
  );
};

export default OpportunityJourneyContainerWrapper;
